"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenTopiaLoader = exports.TopiaLoader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
function TopiaLoader(props) {
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center", children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)("spinner-border inline-block h-8 w-8 animate-spin rounded-full", props.className), role: "status", children: (0, jsx_runtime_1.jsx)("span", { className: "sr-only", children: "Loading..." }) }) }));
}
exports.TopiaLoader = TopiaLoader;
function FullScreenTopiaLoader(props) {
    return ((0, jsx_runtime_1.jsx)("div", { className: "align-center fixed top-0 left-0 z-[1000] flex h-full w-full items-center justify-center bg-black/80", children: (0, jsx_runtime_1.jsx)(TopiaLoader, { className: "text-topia-black" }) }));
}
exports.FullScreenTopiaLoader = FullScreenTopiaLoader;
